import { BaseService } from '@colescba/services'

class ReferenceDataService extends BaseService {
  async menorAcompananteTipos() {
    const response = await this.http.get('/menor-acompanante-tipos')

    return response.data
  }

  async generos() {
    const response = await this.http.get('/generos')
    return response.data
  }

  async vinculosAcreditables() {
    const response = await this.http.get('/vinculos-acreditables')

    return response.data
  }

  async caracteresAutorizantes() {
    const response = await this.http.get('/caracteres-autorizantes')

    return response.data
  }

  async estadosSolicitudes() {
    const response = await this.http.get('/estados-solicitudes')

    return response.data
  }

  async tiposSolicitudes() {
    const response = await this.http.get('/tipos-solicitudes')

    return response.data
  }

  async tiposDocumentos() {
    const response = await this.http.get('/tipos-documentos')

    return response.data
  }

  async paises() {
    const response = await this.http.get('/paises')

    return response.data
  }

  async nacionalidades() {
    const response = await this.http.get('/nacionalidades')

    return response.data
  }

  async tiposFojas() {
    const response = await this.http.get('/tipos-fojas')

    return response.data
  }

  async tiposInstrumentos() {
    const response = await this.http.get('/tipos-instrumentos')

    return response.data
  }

  async solicitudFirmaTipo(provinciaId) {
    const response = await this.http.get('/solicitud-firma-tipo?provinciaId=' + provinciaId)
    return response.data
  }
}

export { ReferenceDataService }
